<template>
  <div
    class="freestar-ad"
    :data-freestar-ad="freestarAd.dimensions"
    :id="freestarAd.id"
  ></div>
</template>

<script lang="ts" setup>
  import { computed, onMounted, toRefs } from 'vue';
  import { useFreestarAds } from '@/composables/useFreestarAds';
  const { FREESTAR_ADS, addFreestarEnabledSlot } = useFreestarAds();

  const props = defineProps<{
    adIdKey: keyof typeof FREESTAR_ADS;
  }>();

  const { adIdKey } = toRefs(props);
  const freestarAd = computed(() => FREESTAR_ADS[adIdKey.value]);

  onMounted(() => {
    addFreestarEnabledSlot(freestarAd.value.id);
  });
</script>

<style scoped>
  .freestar-ad {
    margin: 0px;
  }
</style>
